import React, { useMemo } from 'react';

import { CreateUpdateSalesInvoicePositionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import { VatEnum } from '../../../common/spdCore/validation/enums';
import numberFormatter from '../../../common/numberFormatter';
import mathUtils from '../../../utils/mathUtils';
import { getGrossPrice } from '../../../utils/getVatAmountByVat';

const calculatePositionNetSum = (
  positions: CreateUpdateSalesInvoicePositionDto[],
): string => {
  return positions.reduce((acc, position) => {
    const quantity = (position.quantity ?? 1).toString();
    const total = mathUtils.multiply(position.amount || '0', quantity);
    return mathUtils.add(acc, total).toString();
  }, '0');
};

const calculatePositionGrossSum = (
  positions: CreateUpdateSalesInvoicePositionDto[],
): string => {
  return positions.reduce((acc, position) => {
    const quantity = position.quantity ?? 1;
    const totalAmount = mathUtils.multiply(
      position.amount || '0',
      quantity.toString(),
    );
    const gross = getGrossPrice(
      totalAmount,
      position.vat as unknown as VatEnum,
    );
    return mathUtils.add(acc, gross).toString();
  }, '0');
};

const SalesInvoicePositionsSumRow = ({
  positions,
  parentAmountNet,
  parentAmountGross,
}: {
  positions: CreateUpdateSalesInvoicePositionDto[];
  parentAmountNet?: string;
  parentAmountGross?: string;
}) => {
  const netSum = useMemo(() => calculatePositionNetSum(positions), [positions]);
  const grossSum = useMemo(
    () => calculatePositionGrossSum(positions),
    [positions],
  );

  const correctionNet = useMemo(
    () =>
      parentAmountNet !== undefined
        ? mathUtils.subtract(netSum, parentAmountNet).toString()
        : undefined,
    [netSum, parentAmountNet],
  );
  const correctionGross = useMemo(
    () =>
      parentAmountGross !== undefined
        ? mathUtils.subtract(grossSum, parentAmountGross).toString()
        : undefined,
    [grossSum, parentAmountGross],
  );

  return (
    <>
      <tr className="align-middle">
        <td colSpan={2}></td>
        <td>
          <b>SUMA</b>
        </td>
        <td></td>
        <td></td>
        <td className="amounts-align-right">{numberFormatter(netSum, true)}</td>
        <td></td>
        <td className="amounts-align-right">
          {numberFormatter(grossSum, true)}
        </td>
      </tr>
      {correctionNet !== undefined && correctionGross !== undefined && (
        <tr className="align-middle">
          <td colSpan={2}></td>
          <td>
            <b>Kwota korekty</b>
          </td>
          <td></td>
          <td></td>
          <td className="amounts-align-right">
            {numberFormatter(correctionNet, true)}
          </td>
          <td></td>
          <td className="amounts-align-right">
            {numberFormatter(correctionGross, true)}
          </td>
        </tr>
      )}
    </>
  );
};

export default SalesInvoicePositionsSumRow;
